import { render, staticRenderFns } from "./plat_list.vue?vue&type=template&id=47b3dd16&scoped=true&"
import script from "./plat_list.vue?vue&type=script&lang=js&"
export * from "./plat_list.vue?vue&type=script&lang=js&"
import style0 from "./plat_list.vue?vue&type=style&index=0&id=47b3dd16&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3dd16",
  null
  
)

export default component.exports